import { Styled } from "components/Styled";
import styled from "styled-components";

export const StyledTitle = styled(Styled.H2)`
 @media screen and (min-width: 1000px) {
margin-bottom:48px;
 }
`

export const StyledFormWrapper = styled.div<{
    message: string;
}>`
 width: 100%;
 display:${({ message }) => message !=="" ? "flex" : "block"};
 justify-content:${({ message }) => message !== "" ? "center" : ""};
 align-items:${({ message }) => message !== "" ? "center" : ""};
  @media screen and (min-width: 1000px) {
    width: 50%;
  }

`